import DislikeButton from 'application/components/DislikeButton';
import React, { FC } from 'react';
import { MediaFileTypes } from 'application/pages/types';
import { MediaListProps, MediafileType } from '../../types';

interface MediaListItemIconsDislikeProps {
  id: MediafileType['id'];
  streamId: MediaListProps['streamId'];
  type: MediafileType['type'];
  withDislikes: MediaListProps['withDislikes'];
  isDisliked: boolean;
  onDislike: (value: boolean) => void;
  title: string;
  isLiked: boolean;
}

const MediaListItemIconsDislike: FC<MediaListItemIconsDislikeProps> = (props) => {
  const { id, streamId, type, withDislikes, isDisliked, title, isLiked, onDislike } = props;

  if (!withDislikes) {
    return null;
  }

  return (
    <DislikeButton
      id={id}
      streamId={streamId}
      isDisliked={isDisliked}
      setIsDisliked={onDislike}
      isShow={type === MediaFileTypes.TRACK}
      title={title}
      isLiked={isLiked}
    />
  );
};

export default MediaListItemIconsDislike;
